module.exports = __webpack_public_path__ + "media/images/smart_phone/products/kimutiudon1-0405b73807fab13f48deef102d7da0eb.jpeg";